export { Terms } from './Terms';
export const getTermsUrl = () =>
  'https://www.spotify.com/us/legal/spotify-for-artists-terms-and-conditions/';
